

















































































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import Bus from "@/JS/Bus";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
const zrender = require("zrender");
@Component({
  components: {}
})
export default class extends Vue {
  //$message: any;
  //注入数据 @Provide()
  @Provide()
  private scrollHeight = 600; //当前高度
  private GetAppData: any = {}; //当前应用号信息
  private canvasGroup: any = []; //canvas元素集合
  private canvasBgImg: any = ""; //海报背景图片
  private Effect: any = ""; //海报效果背景
  private canvasZoom: any = 1;
  private temp = -99999;
  private idCount = 1;
  //页面数据集合
  private posterSetData: any = {
    //二维码相关
    qrcode: {
      url: "",
      display: false,
      size: 128,
      x: 0,
      y: 0
    },
    //头像
    avatar: {
      url: "",
      display: false,
      shape: "1", //形状1正方形，2圆形
      size: 128,
      x: 0,
      y: 0
    },
    //昵称
    nickname: {
      display: false,
      fontcolor: "#ff0000",
      fontsize: "24",
      fontfamily: "宋体",
      fontothe: [],
      x: 0,
      y: 0
    },
    //海报回复
    Reply: {
      display: true,
      text:
        "活动名称：[活动名称]\r\n您需要邀请[任务所需关注数]个小伙伴关注公众号后即可领取奖励哦，活动有效期为[活动时间]，当前粉丝海报有效期为[海报有效期]。活动期间多与公众号互动哦，否则可能收不到进展通知。如有疑问请联第在线客服。我们在下方为您准备了转发到群或朋友圈的话术，您可直接使用哦。"
    },
    //规则话术
    Regular: {
      display: true,
      text: "我正在参与[活动名称]活动，大家扫码帮助下，拜托！"
    },
    //任务完成话术
    Complete: {
      display: true,
      text:
        "您已完成克徕帝宠粉日活动任务，点击下面链接去领取吧！\r\n<a href='https://m.crd.cn'>查看详情》》</a>"
    },
    Prize: 500,
    Help: 17,
    //背景参数
    bgimg: {
      width: 0,
      height: 0
    }
  };
  private fontFamilyData = [
    "宋体",
    "仿宋",
    "黑体",
    "隶书",
    "幼圆",
    "楷体",
    "新宋体",
    "新細明體",
    "华文细黑",
    "华文楷体",
    "华文宋体",
    "华文中宋",
    "华文仿宋",
    "方正舒体",
    "方正姚体",
    "华文彩云",
    "华文琥珀",
    "华文隶书",
    "华文行楷",
    "华文新魏",
    "微软雅黑体"
  ];
  //缩小
  canvasOut() {
    this.canvasZoom = this.canvasZoom - 0.01;
    this.loadCanvasData();
    //var temp: any = document.getElementById("elMain");
    // temp.style.zoom = this.canvasZoom;
  }
  //放大
  canvasIn() {
    this.canvasZoom = this.canvasZoom + 0.01;
    this.loadCanvasData();
    // var temp: any = document.getElementById("elMain");
    // temp.style.zoom = this.canvasZoom;
  }

  //初始化
  created() {
    this.$on("PosterDataId", (item: any) => {
      console.log(item);
    });
    this.scrollHeight = document.body.scrollHeight - 260;
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    this.editData();
    Bus.$on("posterInfo", (Item: any) => {
      //this.BasicInformationData = Item;
      if (Item) {
      }
    });

    let posterBg: any = document.getElementById("posterBg");
    this.canvasBgImg = posterBg.src;
    //console.log(this.canvasBgImg);
    //初始化背景
    let img = new Image();
    img.src = this.canvasBgImg;
    let _this = this; // onload 里面不能用this
    img.onload = function() {
      //原始宽度
      _this.posterSetData.bgimg.width = (this as any).width;
      //原始高度
      _this.posterSetData.bgimg.height = (this as any).height;
      //console.log(bgWidth);
      //console.log(bgHeight);
      (document.getElementById("Mycanvas") as any).setAttribute(
        "style",
        "overflow:scroll;width: " +
          _this.posterSetData.bgimg.width +
          "px;height:" +
          _this.scrollHeight +
          "px"
      ); //一次添加多个
      // (document.getElementById("elAside") as any).setAttribute(
      //   "style",
      //   "width: " +
      //     _this.posterSetData.bgimg.width +
      //     "px;height:" +
      //     _this.posterSetData.bgimg.height +
      //     "px;background':'#ffffff;overflow:hidden;"
      // );

      _this.canvasGroup.push({
        type: "bgimg",
        url: _this.canvasBgImg,
        width: _this.posterSetData.bgimg.width,
        height: _this.posterSetData.bgimg.height
      });
    };
    this.refresh();

    // console.log(this.qrcode);
    //头像
    let noavatarImg: any = document.getElementById("noavatarImg");
    this.posterSetData.avatar.url = noavatarImg.src;

    //console.log(this.avatar);
  }
  //修改加载 数据
  async editData() {
    let id = localStorage.getItem("PosterDataId");
    //let id: any = getCookie("PosterId");
    if (id) {
      if (parseInt(id) > 0) {
        let params: any = {
          Input: [
            {
              Name: "PromotePosterListDTO",
              Value: {
                TenantId: this.GetAppData.TenantID,
                Aid: this.GetAppData.Aid,
                PosterId: id
              }
            }
          ]
        };
        var res: any = await httpApi.GetPosterModel(params);
        if (res.ErrorCode == 0) {
          let data = res.output[0].value;
          console.log(data);
          if (data) {
            if (data.BgImg) this.canvasBgImg = data.BgImg;
            if (data.Effect) this.Effect = data.Effect;
            if (data.Prize) this.posterSetData.Prize = data.Prize;
            if (data.Help) this.posterSetData.Help = data.Help;

            if (data.QrCode)
              this.posterSetData.qrcode = JSON.parse(data.QrCode);
            if (data.Avatar)
              this.posterSetData.avatar = JSON.parse(data.Avatar);
            if (data.Nickname)
              this.posterSetData.nickname = JSON.parse(data.Nickname);
            if (data.Reply) this.posterSetData.Reply = JSON.parse(data.Reply);
            if (data.Regular)
              this.posterSetData.Regular = JSON.parse(data.Regular);
            if (data.Complete)
              this.posterSetData.Complete = JSON.parse(data.Complete);
            if (data.BgImgWh)
              this.posterSetData.bgimg = JSON.parse(data.BgImgWh);
            // console.log(data.BgImg);
            Bus.$emit("canvasBgImg", data.BgImg);
            Bus.$emit("Effect", data.Effect);
            this.Effect = data.Effect;
            let imgData: any = {
              type: "bgimg",
              url: data.BgImg
              // width: this.posterSetData.bgimg.width,
              // height: this.posterSetData.bgimg.height
            };
            if (this.posterSetData.bgimg.width)
              imgData.width = this.posterSetData.bgimg.width;
            if (this.posterSetData.bgimg.height)
              imgData.height = this.posterSetData.bgimg.height;
            this.canvasGroup.push(imgData);
            this.refresh();
          }
        } else {
          //res.ErrorMessage
          this.$message.error("加载修改数据失败!" );
        }
      }
    }
  }
  //上传背景图片
  getFile(file: any, fileList: any) {
    console.log(this.canvasGroup);
    console.log(JSON.stringify(this.canvasGroup));
    if (this.canvasGroup.length > 0) {
      this.canvasGroup.forEach((data: any, index: number) => {
        if (data.type == "bgimg") {
          this.canvasGroup.splice(index, 1);
        }
      });
      console.log(this.canvasGroup);
    }
    this.getBase64(file.raw).then(res => {
      //console.log(res);
      this.canvasBgImg = String(res);
      //this.posterSetData.bgimg.url = this.canvasBgImg;
      Bus.$emit("canvasBgImg", this.canvasBgImg);
      let img = new Image();
      img.src = this.canvasBgImg;
      let _this = this; // onload 里面不能用this
      img.onload = function() {
        //原始宽度
        _this.posterSetData.bgimg.width = (this as any).width;
        //原始高度
        _this.posterSetData.bgimg.height = (this as any).height;
        //console.log(bgWidth);
        //console.log(bgHeight);
        (document.getElementById("Mycanvas") as any).setAttribute(
          "style",
          "overflow:scroll;width: " +
            _this.posterSetData.bgimg.width +
            "px;height:" +
            _this.scrollHeight +
            "px"
        ); //一次添加多个
        // (document.getElementById("elAside") as any).setAttribute(
        //   "style",
        //   "width: " +
        //     _this.posterSetData.bgimg.width +
        //     "px;height:" +
        //     _this.posterSetData.bgimg.height +
        //     "px;background':'#ffffff;overflow:hidden;"
        // );

        _this.canvasGroup.push({
          type: "bgimg",
          url: _this.canvasBgImg,
          width: _this.posterSetData.bgimg.width,
          height: _this.posterSetData.bgimg.height
        });
        _this.loadCanvasData();
        _this.refresh();
        (_this as any).$refs.upload.clearFiles();
        /*var container: any = document.getElementById("Mycanvas");
        var zr = zrender.init(container);
        let group: any = new zrender.Group();
        //绘画图片
        let imgdata = new zrender.Image({
          style: {
            image:  _this.canvasBgImg,
            x: 0,
            y: 0,
            width: bgWidth,
            height: bgHeight
          },
          draggable: false
        });
        container.width = bgWidth;
        container.height = bgHeight;
        //console.log(imgdata);
        group.add(imgdata);
        zr.add(group);
        //_this.container.width = bgWidth;
        //_this.container.height = bgHeight;
        */
      };
    });
  }
  //把图片Base64
  getBase64(file: any) {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();
      let imgResult: any = "";
      reader.readAsDataURL(file);
      reader.onload = function() {
        imgResult = reader.result;
      };
      reader.onerror = function(error) {
        reject(error);
      };
      reader.onloadend = function() {
        resolve(imgResult);
      };
    });
  }

  //刷新数据
  refresh() {
    this.canvasGroup.forEach((data: any, index: number) => {
      if (data.type != "bgimg") {
        // this.posterSetData.qrcode.x = data.x;
        //this.posterSetData.qrcode.y = data.y;
        this.canvasGroup.splice(index, 1);
      }
    });
    //console.log(this.posterSetData);
    //二维码
    if (this.posterSetData.qrcode.display) {
      let crdcodeImg: any = document.getElementById("crdcodeImg");
      console.log(crdcodeImg);
      this.posterSetData.qrcode.url = crdcodeImg.src;
      this.canvasGroup.push({
        type: "qrcode",
        url: this.posterSetData.qrcode.url,
        width: this.posterSetData.qrcode.size,
        height: this.posterSetData.qrcode.size,
        x: this.posterSetData.qrcode.x,
        y: this.posterSetData.qrcode.y
      });
    } else {
      this.canvasGroup.forEach((element: any, index: number) => {
        if (element.type == "qrcode") {
          this.canvasGroup.splice(index, 1);
        }
      });
    }
    //头像
    if (this.posterSetData.avatar.display) {
      let noavatarImg: any = document.getElementById("noavatarImg");
      //console.log(crdcodeImg);
      this.posterSetData.avatar.url = noavatarImg.src;
      this.canvasGroup.push({
        type: "avatar",
        url: this.posterSetData.avatar.url,
        width: this.posterSetData.avatar.size,
        height: this.posterSetData.avatar.size,
        shape: this.posterSetData.avatar.shape,
        x: this.posterSetData.avatar.x,
        y: this.posterSetData.avatar.y
      });
    } else {
      this.canvasGroup.forEach((element: any, index: number) => {
        if (element.type == "avatar") {
          this.canvasGroup.splice(index, 1);
        }
      });
    }
    //昵称
    if (this.posterSetData.nickname.display) {
      this.canvasGroup.push({
        type: "nickname",
        fontcolor: this.posterSetData.nickname.fontcolor,
        fontsize: this.posterSetData.nickname.fontsize,
        fontfamily: this.posterSetData.nickname.fontfamily,
        x: this.posterSetData.nickname.x,
        y: this.posterSetData.nickname.y
      });
    } else {
      this.canvasGroup.forEach((element: any, index: number) => {
        if (element.type == "nickname") {
          this.canvasGroup.splice(index, 1);
        }
      });
    }
    //console.log(this.canvasGroup);
    this.loadCanvasData();
    Bus.$emit("posterSetData", this.posterSetData);
  }
  //加载画布中所有元素
  loadCanvasData() {
    var _this = this;
    var container: any = document.getElementById("Mycanvas");
    var opts: any = {
      width: this.posterSetData.bgimg.width,
      height: this.posterSetData.bgimg.height,
      devicePixelRatio: 1
    };
    var zr = zrender.init(container, opts);
    let group: any = new zrender.Group();

    this.canvasGroup = this.unique(this.canvasGroup);
    this.canvasGroup.forEach((data: any) => {
      if (data.type == "bgimg") {
        //绘画背景图片
        data.width = parseInt(data.width) * parseFloat(this.canvasZoom);
        data.height = parseInt(data.height) * parseFloat(this.canvasZoom);
        //console.log(data.height +"-"+ data.width );
        let imgdata = new zrender.Image({
          style: {
            image: data.url,
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
          },
          cursor: "defult",
          zlevel: -999999,
          id: this.idCount,
          draggable: false,
          scale: [this.canvasZoom, this.canvasZoom]
        });
        container.width = data.width;
        container.height = data.height;
        //console.log(imgdata);
        group.add(imgdata);
      } else {
        if (data.x == 0) {
          data.x = this.posterSetData.bgimg.width / 2;
        }
        if (data.y == 0) {
          data.y = this.posterSetData.bgimg.height / 2;
        }
      }
      if (data.type == "qrcode") {
        //二维码
        let imgdata = new zrender.Image({
          style: {
            image: data.url,
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
          },
          zlevel: this.temp,
          id: this.idCount,
          draggable: true,
          scale: [this.canvasZoom, this.canvasZoom]
        })
          .on("mousedown", function(e: any) {
            //鼠标按下事件
          })
          .on("mouseup", function(e: any) {
            //鼠标放开事件
            // console.log(e.event);
            data.x = e.event.zrX - data.width / 2;
            data.y = e.event.zrY - data.height / 2;
            //宽度超过画布
            if (data.x > _this.posterSetData.bgimg.width - data.width) {
              data.x = _this.posterSetData.bgimg.width - data.width;
            }
            //高度超过画布
            if (data.y > _this.posterSetData.bgimg.height - data.height) {
              data.y = _this.posterSetData.bgimg.height - data.height;
            }

            _this.canvasGroup.forEach((data: any, index: number) => {
              if (data.type == "qrcode") {
                _this.canvasGroup.splice(index, 1);
                _this.posterSetData.qrcode.x = data.x;
                _this.posterSetData.qrcode.y = data.y;
                _this.canvasGroup.push(data);
              }
            });
          })
          .on("dblclick", function(ev: any) {
            console.log(ev);
            ev.topTarget.rotation = ev.topTarget.rotation - Math.PI / 12;
            //设置旋转角度
            //	this.attr('rotation',[this.rotation-Math.PI/12]);
            //设置旋转中心
            //this.attr('origin',[this.style.x+this.style.width/2,this.style.y+this.style.height/2]);
          });
        group.add(imgdata);
      }
      if (data.type == "avatar") {
        //头像
        let imgdata = new zrender.Image({
          style: {
            image: data.url,
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
          },
          zlevel: this.temp,
          id: this.idCount,
          draggable: true,
          scale: [this.canvasZoom, this.canvasZoom]
        })
          .on("mouseup", function(e: any) {
            // console.log(e.event);
            data.x = e.event.zrX - data.width / 2;
            data.y = e.event.zrY - data.height / 2;
            //宽度超过画布
            if (data.x > _this.posterSetData.bgimg.width - data.width) {
              data.x = _this.posterSetData.bgimg.width - data.width;
            }
            //高度超过画布
            if (data.y > _this.posterSetData.bgimg.height - data.height) {
              data.y = _this.posterSetData.bgimg.height - data.height;
            }
            _this.canvasGroup.forEach((data: any, index: number) => {
              if (data.type == "avatar") {
                _this.canvasGroup.splice(index, 1);
                _this.posterSetData.avatar.x = data.x;
                _this.posterSetData.avatar.y = data.y;
                _this.canvasGroup.push(data);
              }
            });
          })
          .on("dblclick", function(ev: any) {
            //设置旋转角度
            //	this.attr('rotation',[this.rotation-Math.PI/12]);
            //设置旋转中心
            //this.attr('origin',[this.style.x+this.style.width/2,this.style.y+this.style.height/2]);
          });
        //console.log(data.shape);
        if (data.shape == 2) {
          var clipPath = new zrender.Circle({
            shape: {
              cx:
                _this.posterSetData.avatar.x +
                _this.posterSetData.avatar.size / 2,
              cy:
                _this.posterSetData.avatar.y +
                _this.posterSetData.avatar.size / 2,
              r: _this.posterSetData.avatar.size / 2
            }
          });
          imgdata.setClipPath(clipPath);
        }
        group.add(imgdata);
      }
      if (data.type == "nickname") {
        //粉丝昵称
        let fontStyle = "";
        if (_this.posterSetData.nickname.fontothe.length > 0) {
          _this.posterSetData.nickname.fontothe.forEach((x: any) => {
            if (x == "Bold") {
              fontStyle = fontStyle + " Bold";
            }
            if (x == "Italic") {
              fontStyle = fontStyle + " Italic";
            }
          });
        }
        var smText = new zrender.Text({
          style: {
            text: "粉丝昵称",
            x: data.x,
            y: data.y,
            fontSize: data.fontsize,
            fontFamily: data.fontfamily,
            textFill: data.fontcolor,
            textAlign: "left",
            textVerticalAlign: "top",
            fontStyle: fontStyle
          },
          zlevel: this.temp,
          id: this.idCount,
          draggable: true,
          scale: [this.canvasZoom, this.canvasZoom]
        })
          .on("mouseup", function(e: any) {
            // console.log(e.event);
            data.x = e.event.zrX;
            data.y = e.event.zrY;
            //宽度超过画布
            if (data.x > _this.posterSetData.bgimg.width) {
              data.x = _this.posterSetData.bgimg.width;
            }
            //高度超过画布
            if (data.y > _this.posterSetData.bgimg.height) {
              data.y = _this.posterSetData.bgimg.height;
            }
            _this.canvasGroup.forEach((data: any, index: number) => {
              if (data.type == "nickname") {
                _this.canvasGroup.splice(index, 1);
                _this.posterSetData.nickname.x = data.x;
                _this.posterSetData.nickname.y = data.y;
                _this.canvasGroup.push(data);
              }
            });
          })
          .on("dblclick", function(ev: any) {
            //设置旋转角度
            //	this.attr('rotation',[this.rotation-Math.PI/12]);
            //设置旋转中心
            //this.attr('origin',[this.style.x+this.style.width/2,this.style.y+this.style.height/2]);
          });
        //console.log(data);
        group.add(smText);
      }
      this.idCount++;
    });
    zr.add(group);
    this.Effect = zr.painter.getRenderedCanvas().toDataURL();
    if (this.Effect) {
      Bus.$emit("Effect", this.Effect);
    }
  }
  //去重复数据
  unique(arr: any) {
    for (var i = 0; i < arr.length; i++) {
      // console.log(arr[i]);
      for (var j = i + 1; j < arr.length; j++) {
        if (arr[i].url == arr[j].url) {
          //第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }
}
